const BASE = '/api/meals';
function token() { return localStorage.getItem('meal_token') || ''; }
function headers() { return { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` }; }
async function req(method, path, body) {
  const res = await fetch(BASE + path, { method, headers: headers(), body: body ? JSON.stringify(body) : undefined });
  if (res.status === 401) { localStorage.removeItem('meal_token'); window.location.href = '/'; }
  if (!res.ok) { const err = await res.json().catch(() => ({})); throw new Error(err.detail || 'Ошибка сервера'); }
  if (res.status === 204) return null;
  return res.json();
}
export const api = {
  login: (email, password) => req('POST', '/auth/login', { email, password }),
  me: () => req('GET', '/auth/me'),
  hotels: () => req('GET', '/hotels'),
  day: (day) => req('GET', `/day?day=${day}`),
  session: (id) => req('GET', `/sessions/${id}`),
  sync: (hotel_id, day) => req('POST', `/sync?hotel_id=${hotel_id}&day=${day}`),
  syncAll: (day) => req('POST', `/sync-all?day=${day}`),
  addRecord: (session_id, data) => req('POST', `/sessions/${session_id}/records`, data),
  updateRecord: (id, data) => req('PUT', `/records/${id}`, data),
  deleteRecord: (id) => req('DELETE', `/records/${id}`),
  confirm: (session_id) => req('POST', `/sessions/${session_id}/confirm`),
  unlock: (session_id) => req('POST', `/sessions/${session_id}/unlock`),
  deleteSession: (session_id) => req('DELETE', `/sessions/${session_id}`),
  confirmAll: (day) => req('POST', `/confirm-all?day=${day}`),
  reports: (params) => req('GET', `/reports?${new URLSearchParams(params)}`),
  users: () => req('GET', '/users'),
  createUser: (data) => req('POST', '/users', data),
  deleteUser: (id) => req('DELETE', `/users/${id}`),
  createHotel: (data) => req('POST', '/hotels', data),
  updateHotel: (id, data) => req('PATCH', `/hotels/${id}`, data),
  deleteHotel: (id) => req('DELETE', `/hotels/${id}`),
  sendIiko: (date) => req('POST', '/iiko/send', { date }),
  createSession: (hotelId, day) => req('POST', `/sessions?hotel_id=${hotelId}&day=${day}`),
  exportExcel: async (params) => {
    const res = await fetch(BASE + '/reports/export?' + new URLSearchParams(params), { headers: headers() });
    if (!res.ok) throw new Error('Ошибка экспорта');
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'Питание_' + (params.date_from || '') + '_' + (params.date_to || '') + '.xlsx';
    a.click();
    URL.revokeObjectURL(url);
  },
};
export function today() { return new Date().toISOString().split('T')[0]; }
export function tomorrow() { const d = new Date(); d.setDate(d.getDate() + 1); return d.toISOString().split('T')[0]; }
export function fmtDate(d) { if (!d) return '—'; return new Date(d).toLocaleString('ru-RU', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }); }
export const MEAL_LABELS = { breakfast: '🍳 Завтрак', dinner: '🍽 Ужин', lunch: '🥗 Обед', other: '☕ Прочее' };
